<template>
  <div>
    <div class="row" style="box-shadow: 0px 4px 2px #acaaaa">
      <div class="col-md-2">
        <h6>
          Batch Name <br />
          <small class="text-color">{{ TimePeriod[0].batchName }}</small>
        </h6>
      </div>
      <div class="col-md-2">
        <h6>
          Service Pay Date <br />
          <small class="text-color">
            {{ dobformat2(TimePeriod[0].payDate) }}</small
          >
        </h6>
      </div>
      <div class="col-md-2">
        <h6>
          Service Period <br />
          <small class="text-color"
            >{{ dobformat2(TimePeriod[0].startDate) }} -
            {{ dobformat2(TimePeriod[0].endDate) }}</small
          >
        </h6>
      </div>
      <div class="col-md-3">
        <v-text-field
          class="pt-0 mt-0"
          label="Search by Name or ID"
          v-model="Search"
        ></v-text-field>
      </div>
    </div>

    <div class="row mt-9 pt-12" style="height: 140px">
      <div class="col-md-6">
        <div>
          <h4>Search Results</h4>
        </div>
        <div class="d-flex">
          <h6>{{ numberOfRecord }}</h6>
          <span class="pl-2">Records(s) Founds</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3">
            <h6>
              {{ payableHours }} <br />
              <small class="text-color"> <b>Hours</b> </small>
            </h6>
          </div>
          <div class="col-md-3">
            <h6>
              $ {{ payableRate }}<br />
              <small class="text-color"><b>Payroll Total</b></small>
            </h6>
          </div>
          <div class="col-md-3">
            <h6>
              {{ noOfCareGiver }}<br />
              <small class="text-color"><b>Caregivers(s) </b></small>
            </h6>
          </div>
          <div class="col-md-3">
            <h6>
              {{ noOfClient }}<br />
              <small class="text-color"><b>Client(s)</b></small>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-15" style="background-color: #ffffff">
      <!-- <b-table
        class="tabledata table-bordered"
        show-empty
        :items="items"
        select-mode="single"
        :fields="fields"
        selectable
        hidden
        striped
        hover
      >
      </b-table> -->

      <v-data-table
        :headers="headersParent"
        :items="freshRecord"
        :expanded.sync="expanded"
        item-key="empName"
        class="elevation-1 ParentTable"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <!-- <template #[`item.data-table-select`]="{ isSelected, select }">
          <v-simple-checkbox
            color="primary"
            :value="isSelected"
            @input="select($event)"
          ></v-simple-checkbox>
        </template> -->

        <template #[`item.empName`]="{ item, index }">
          <v-data-table
            :headers="index === 0 ? headersPayrate : headersPayrate2"
            :items="item.rates"
            :hide-default-footer="true"
            :key="index"
          >
            <template #[`item.WorkerName`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                item.empName
              }}</span>
            </template>
            <template #[`item.WorkerID`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                item.empID
              }}</span>
            </template>
            <template #[`item.PayComp`]="{ item }">
              <span style="color: blue; font-weight: bold">Regular</span>
            </template>
            <template #[`item.Hours`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                HoursAdd(item)
              }}</span>
            </template>
            <template #[`item.Rate`]="{ item }">
              <span style="color: blue; font-weight: bold">{{
                item.payRate
              }}</span>
            </template>
            <template #[`item.Subcode`]="{ item }">
              <span style="color: blue; font-weight: bold"></span>
            </template>
            <template #[`item.Client`]="{ item }">
              <span style="color: blue; font-weight: bold"></span>
            </template>
            <template #[`item.DateRange`]="{ item }">
              <span style="color: blue; font-weight: bold"></span>
            </template>
          </v-data-table>
        </template>

        <template #expanded-item="{ headers, item }">
          <td class="px-0 py-2" :colspan="headers.length">
            <v-data-table
              v-model="selectedChild"
              :headers="headersChild"
              :items="item.data"
              item-key="name"
              elevation="0"
            >
              <template #[`item.WorkerName`]="{ item }">
                <span>{{ item.empName }}</span>
              </template>
              <template #[`item.WorkerID`]="{ item }">
                <span>{{ item.empID }}</span>
              </template>
              <template #[`item.PayComp`]="{ item }">
                <span>Regular</span>
              </template>
              <template #[`item.Hours`]="{ item }">
                <span>{{ item.actualHours.toFixed(2) }}</span>
              </template>
              <template #[`item.Rate`]="{ item }">
                <span>{{ item.payRate }}</span>
              </template>
              <template #[`item.Subcode`]="{ item }">
                <span>{{ item.subCode }}</span>
              </template>
              <template #[`item.Client`]="{ item }">
                <span>{{ item.clientName }}</span>
              </template>
              <template #[`item.DateRange`]="{ item }">
                {{
                  dobformat(
                    item.editStartTimeDate != null
                      ? item.editStartTimeDate
                      : item.startTimeDate
                  )
                }}
                -
                {{
                  dobformat(
                    item.editEndTimeDate != null
                      ? item.editEndTimeDate
                      : item.endTimeDate
                  )
                }}
              </template>
              <!-- <template #[`header.data-table-select`]="{ on, props }">
                <v-simple-checkbox
                  color="purple"
                  v-bind="props"
                  v-on="on"
                ></v-simple-checkbox>
              </template> -->

              <!-- <template #[`item.data-table-select`]="{ isSelected, select }">
                <v-simple-checkbox
                  color="purple"
                  :value="isSelected"
                  @input="select($event)"
                ></v-simple-checkbox>
              </template> -->

              <template #[`item.startTimeDate`]="{ item }">
                {{ dobformat(item.startTimeDate) }} -
                {{ dobformat(item.endTimeDate) }}
              </template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
    </div>
    <div>
      <!-- <b-table responsive xl :items="items"></b-table> -->
    </div>
    <div style="height: 100px">
      <div class="float-right mt-10">
        <span class="m-4">
          <a class="btn btn-success btn-sm" @click="ExportPaychex"
            >Paychex export
          </a>
        </span>
        <span class="m-4">
          <a class="btn btn-success btn-sm" @click="htmlToCSV"
            >Export to Excel
          </a>
        </span>
        <span class="m-4">
          <a class="btn btn-danger btn-sm" v-b-modal.confirmAuthModal
            >Delete Batch
          </a>
        </span>
      </div>
    </div>
    <!-- <div style="text-align: center">
      <span class="m-4">
        <a class="btn btn-success btn-sm">Paychex export </a>
      </span>
      <span class="m-4">
        <a class="btn btn-success btn-sm">Export to Excel </a>
      </span>
      <span class="m-4">
        <a class="btn btn-danger btn-sm">Delete Batch </a>
      </span>
    </div> -->
    <b-modal
      centered
      text
      id="confirmAuthModal"
      title="Are you sure you want to Delete this?"
      hide-footer
    >
      <div class="text-center">
        <span class="green-btn">
          <a class="btn btn-success mr-3" @click="CloseModel"
            ><span
              >Delete
              <span v-if="loader">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular> </span></span
          ></a>
        </span>
        <span class="green-btn">
          <a
            class="btn btn-danger mr-3"
            @click="$bvModal.hide('confirmAuthModal')"
            ><span>Cancel</span></a
          >
        </span>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "processpayrollscreen2",
  props: ["form"],
  data() {
    return {
      showData: true,
      freshRecord: [],
      modalShow: false,
      closemodel: true,
      selectedChild:'',
      selected: [],
      items: [],
      Services: [],
      Search: "",
      loader: false,
      fields: [
        {
          label: "Employee",
          key: "empName",
        },
        {
          label: "Client",
          key: "clientName",
        },
        {
          label: "Start Time",
          key: "startTimeDate",
        },
        {
          label: "End Time",
          key: "endTimeDate",
        },
        {
          label: "ServiceorSubCode",
          key: "subCode",
        },
        {
          label: "Hours",
          key: "payableHours",
        },
        {
          label: "Rate",
          key: "payRate",
        },
        {
          label: "OT",
          key: "OT",
        },
      ],

      headersParent: [
        // {
        //   text: 'Select',
        //   align: 'left',
        //   value: 'data-table-select',
        //   class: 'checkbox',
        //   cellClass: 'checkbox'
        // },
        {
          text: "",
          align: "left",
          value: "empName",
          width: "100%",
          sortable: false,
        },
        // { text: "Date Range", value: "startTimeDate", width: "15%" },

        // //{ text: "End Time", value: "endTimeDate" ,    width:'15%'},
        // { text: "Service/Sub Code", value: "subCode", width: "15%" },
        // {
        //   text: "Client",
        //   align: "left",
        //   value: "clientName",
        //   width: "15%",
        // },
        // { text: "Hours", value: "payableHours", width: "15%" },

        // { text: "Rate", value: "payRate", width: "15%" },
        // { text: "OT", value: "OT", width: "15%" },
        // { text: "OT Rate", value: "OT Rate", width: "15%" },
      ],
      headersPayrate: [
        {
          text: "Worker Name",
          align: "left",
          value: "WorkerName",
          width: "15%",
          sortable: false,
        },
        {
          text: "Worker ID",
          align: "left",
          value: "WorkerID",
          width: "15%",
          sortable: false,
        },
        {
          text: "Pay Comp",
          align: "left",
          value: "PayComp",
          width: "15%",
          sortable: false,
        },
        {
          text: "Hours",
          align: "left",
          value: "Hours",
          width: "15%",
          sortable: false,
        },
        {
          text: "Rate",
          align: "left",
          value: "Rate",
          width: "15%",
          sortable: false,
        },
        {
          text: "Service/Subcode",
          align: "left",
          value: "Subcode",
          width: "15%",
          sortable: false,
        },
        {
          text: "Client",
          align: "left",
          value: "Client",
          width: "15%",
          sortable: false,
        },
        {
          text: "Date Range",
          align: "left",
          value: "DateRange",
          width: "15%",
          sortable: false,
        },
        // { text: "Hours", value: "payableHours", width: "15%" },
        // { text: "Rate", value: "payRate", width: "15%" },
        // { text: "OT", value: "OT", width: "15%" },
        // { text: "OT Rate", value: "OT Rate", width: "15%" },
      ],
      headersChild: [
        {
          text: " ",
          align: "left",
          value: "WorkerName",
          width: "16.8%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "WorkerID",
          width: "16.8%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "PayComp",
          width: "16.8%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Hours",
          width: "16.8%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Rate",
          width: "16.8%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Subcode",
          width: "16.8%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Client",
          width: "16.8%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "DateRange",
          width: "16.8%",
          sortable: false,
        },
        // { text: "Hours", value: "payableHours", width: "15%" },
        // { text: "Rate", value: "payRate", width: "15%" },
        // { text: "OT", value: "OT", width: "15%" },
        // { text: "OT Rate", value: "OT Rate", width: "15%" },
      ],
      headersPayrate2: [
        {
          text: " ",
          align: "left",
          value: "WorkerName",
          width: "14.4%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "WorkerID",
          width: "14.4%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "PayComp",
          width: "14.4%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Hours",
          width: "14.4%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Rate",
          width: "14.4%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Subcode",
          width: "14.4%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "Client",
          width: "14.4%",
          sortable: false,
        },
        {
          text: " ",
          align: "left",
          value: "DateRange",
          width: "14.4%",
          sortable: false,
        },
        // { text: "Hours", value: "payableHours", width: "15%" },
        // { text: "Rate", value: "payRate", width: "15%" },
        // { text: "OT", value: "OT", width: "15%" },
        // { text: "OT Rate", value: "OT Rate", width: "15%" },
      ],
      treats: [],
    };
  },
  watch: {
    Search: {
      handler: function () {
        this.searchedData();
      },
    },
  },
  computed: {
    ...mapGetters(["TimePeriod", "getWorkedHour", "ClientCount"]),
    numberOfRecord() {
      var totalRecords = 0;
      this.TimePeriod.forEach((e) => {
        totalRecords += e.data.length;
      });
      return totalRecords;
    },
    payableHours() {
      if (this.TimePeriod) {
        var hours = 0;
        this.TimePeriod.forEach((element) => {
          element.data.forEach((p) => {
            hours = hours + p.payableHours;
          });
        });

        return Math.round(hours * 100) / 100;
      } else {
        return 0;
      }
    },
    payableRate() {
      if (this.TimePeriod) {
        var rate = 0;
        this.TimePeriod.forEach((element) => {
          element.data.forEach((p) => {
            var amount = (Math.round(p.actualHours * 100) / 100) * p.payRate;
            rate = rate + amount;
          });
        });

        return Math.round(rate * 100) / 100;
      } else {
        return 0;
      }
    },
    noOfCareGiver() {
      if (this.TimePeriod) { 
        var employees = [];
        this.TimePeriod.forEach((x) => {
          if (!employees.includes(x.empID)) {
            employees.push(x.empID);
          }
        });
        return employees.length;
      } else {
        return 0;
      }
    },
    noOfClient() {
      var clients = [];
      if (this.TimePeriod) {
        this.TimePeriod.forEach((x) => {
          if (!clients.includes(x.clientId)) {
            clients.push(x.clientId);
          }
        });
        return clients.length;
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.freshRecord = this.TimePeriod;
  },

  methods: {
    searchedData() {
      if (this.Search == "") {
        this.freshRecord = this.TimePeriod;
      } else {
        this.freshRecord = this.freshRecord.filter((e) => {
          return (
            e.empID.includes(this.Search) ||
            e.empName.toLowerCase().includes(this.Search.toLowerCase())
          );
        });
      }
    },
    HoursAdd(hours) {
      var sum = 0;
      this.TimePeriod.forEach((t) => {
        if (t.empID == hours.empID) {
          t.data.forEach((r) => {
            if (r.payRate == hours.payRate) {
              sum += r.actualHours;
            }
          });
        }
      });
      return sum.toFixed(2);
    },
    dobformat(obj) {
      if (obj) {
        var date = new Date(obj);
        return (
          (date.getMonth() > 8
            ? date.getMonth() + 1
            : "0" + (date.getMonth() + 1)) +
          "/" +
          (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
          "/" +
          date.getFullYear() +
          " " +
          date.toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          })
        );
      }
    },
    ExportPaychex() {
      var filename = this.TimePeriod[0].batchName;
      var Services = [];
      var Employee = [];
      var data = [];
      var header = "";
      this.TimePeriod.forEach((T) => {
        if (!Services.includes(T.payRate)) {
          Services.push(T.payRate);
        }
      });
      this.TimePeriod.forEach((T) => {
        if (!Employee.includes(T.empName)) {
          Employee.push(T.empName);
        }
      });

      header = `"Client ID ","Worker Name","Worker ID",Org,"Job Number","Pay Component",Rate,"Rate Number","Hours",Units,"Line Date",Amount,"Check Seq Number","Override Local","Override Local Jurisdiction","Labor Assignment","Override State"`;
      data.push(header);
      Employee.forEach((E, Ei) => {
        this.TimePeriod.forEach((T) => {
          if (T.empName == E) {
            T.rates.forEach((p) => {
              var row = `"A8302570 ","${T.empName}","'${
                T.empID
              }'","","","Regular","${p.payRate}","","${this.HoursAdd(
                p
              )}","","","","","","","",""`;
              data.push(row);
            });
          }
        });
      });
      console.table(data);
      this.downloadCSVFile(data.join("\n"), filename);
    },
    htmlToCSV() {
      var filename = this.TimePeriod[0].batchName;
      var Services = [];
      var Employee = [];
      var data = [];
      var header = "";
      this.TimePeriod.forEach((T) => {
        if (!Services.includes(T.payRate)) {
          Services.push(T.payRate);
        }
      });
      this.TimePeriod.forEach((T) => {
        if (!Employee.includes(T.empName)) {
          Employee.push(T.empName);
        }
      });

      header = `"Client ID","Worker Name","Worker ID",Org,"Job Number","Pay Component",Rate,"Rate Number","Hours",Units,"Line Date",Amount,"Check Seq Number","Override Local","Override Local Jurisdiction","Labor Assignment","Override State"`;
      data.push(header);
      this.TimePeriod.forEach((T, ti) => {
        T.data.forEach((p) => {
          if (p.empName == T.empName) {
            var row = `"A8302570 ","${T.empName}","'${
              T.empID
            }'","","","Regular","${p.payRate}","","${p.payableHours.toFixed(
              2
            )}","","","","","","","",""`;
            data.push(row);
          }
        });

        data.push("");
        data.push("");
      });
      this.downloadCSVFile(data.join("\n"), filename);
    },
    processRow(rowData) {
      var row = Object.values(rowData);
      var finalVal = "";
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? "" : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ",";
        finalVal += result;
      }
      return finalVal + "\n";
    },
    headerRow(rowData) {
      var row = Object.getOwnPropertyNames(rowData);
      var finalVal = "";
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? "" : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ",";
        if (result == "empID") {
          result = "Employee ID";
        }
        if (result == "empName") {
          result = "Staff Name";
        }
        finalVal += result;
      }
      return finalVal + "\n";
    },
    exportToCsv(filename, rows, dates) {
      var csvFile = "";

      csvFile += "Process PayRoll (CSV) From " + dates + "\n";
      csvFile += this.headerRow(rows[rows.length - 1]);
      for (var i = 0; i < rows.length; i++) {
        csvFile += this.processRow(rows[i]);
      }

      var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    downloadCSVFile(csv, filename) {
      var csv_file, download_link;

      csv_file = new Blob([csv], { type: "text/csv" });

      download_link = document.createElement("a");

      download_link.download = filename;

      download_link.href = window.URL.createObjectURL(csv_file);

      download_link.style.display = "none";

      document.body.appendChild(download_link);

      download_link.click();
    },
    modalshow() {
      this.modalShow = true;
    },
    RESET() {
      this.$bvModal.hide("modal-center");
    },
    async CloseModel() {
      this.loader = true;

      await this.$store
        .dispatch("removepayRoll", this.TimePeriod[0].payRollId)
        .then((r) => {
          if (r.status) {
            this.$store.dispatch("GetBatchName");
            this.$bvModal.hide("confirmAuthModal");
            Swal.fire({
              title: "",
              text: "Success!",
              icon: "success",
              confirmButtonClass: "btn btn-primary",
            });
          } else {
            Swal.fire({
              title: "",
              text: "Failed!",
              icon: "failed",
              confirmButtonClass: "btn btn-primary",
            });
          }

          this.loader = false;
        });

      this.$bvModal.hide("Action");
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    dobformat2(obj) {
      if (obj) {
        var date = new Date(obj);
        return (
          (date.getMonth() > 8
            ? date.getMonth() + 1
            : "0" + (date.getMonth() + 1)) +
          "/" +
          (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
          "/" +
          date.getFullYear()
        );
      }
    },
  },
};
</script>

<style scoped>
.text-color {
  color: #2d79bd;
}
.table thead th,
.table thead td {
  padding: 0px 40px !important;
  font-weight: 600;
  font-size: 1rem;
  border-bottom-width: 1px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
